import { Link } from "react-router-dom";

export default function LinkToGroupManagement({groupId}) {
  if (!groupId) {
    return null;
  }

  return (
    <>
      /&nbsp;
      <Link to={"/groups/" + groupId + "/manage"} className="font-medium text-green-600 underline hover:no-underline">
        Gerenciar Bolão
      </Link>
    </>
  )
}
